import React, { useRef, useState } from "react";
import {
    Button,
    Col,
    Glyphicon,
    Row,
    FormGroup,
    FormControl,
    ControlLabel,
    Table,
} from "react-bootstrap";
import { quizQuestionAnswerCreate, quizQuestionAnswerUpdate } from "../../../../../../api/cp";
import DeleteConfirmOverlay from "../../../../UI/DeleteConfirmOverlay";

const AnswerEditor = ({ answer, poll, onDelete }) => {
    const [id, setId] = useState(answer?.id);
    const [textRu, setTextRu] = useState(answer?.textRu || '');
    const [textEn, setTextEn] = useState(answer?.textEn || '');
    const [isSaving, setSaving] = useState(false);

    const saveProperty = async (name, value) => {
        setSaving(true);
        try {
            let answer;
            if (id) {
                answer = await quizQuestionAnswerUpdate(id, { [name]: value });
            } else {
                answer = await quizQuestionAnswerCreate(poll.id, { [name]: value });
            }
            setId(answer.id);
            setTextRu(answer.textRu);
            setTextEn(answer.textEn);
        } catch (e) {
            console.error(e);
        }
        setSaving(false);
    }

    return (
        <tr>
            <td>
                <FormControl
                    type="text"
                    value={textRu}
                    onChange={(e) => setTextRu(e.target.value)}
                    onBlur={() => saveProperty('textRu', textRu)}
                    disabled={isSaving}
                />
            </td>
            <td>
                <FormControl
                    type="text"
                    value={textEn}
                    onChange={(e) => setTextEn(e.target.value)}
                    onBlur={() => saveProperty('textEn', textEn)}
                    disabled={isSaving}
                />
            </td>
            <td>
                <DeleteConfirmOverlay title="Удалить ответ вопроса?" onConfirm={onDelete}>
                    <Button bsStyle="danger" disabled={isSaving}><Glyphicon glyph="trash" /></Button>
                </DeleteConfirmOverlay>
            </td>
        </tr>
    );
}

export default ({ poll, setProperty, saveProperty, savePropertyFile, createAnswer, deleteAnswer }) => {
    const imageInputRef = useRef(null);

    if (!poll) return null;

    return <>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Вопрос [Ru]</ControlLabel>
                    <FormControl
                        type="textarea"
                        value={poll.textRu}
                        onChange={e => setProperty('textRu', e.target.value)}
                        onBlur={(e) => saveProperty('textRu', poll.textRu)}
                        placeholder="Вопрос"
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Вопрос [En]</ControlLabel>
                    <FormControl
                        type="textarea"
                        value={poll.textEn}
                        onChange={e => setProperty('textEn', e.target.value)}
                        onBlur={(e) => saveProperty('textEn', poll.textEn)}
                        placeholder="Question"
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <FormGroup>
                        <ControlLabel>Изображение вопроса</ControlLabel>
                        {poll.imageUrl && <div><img src={poll.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                        <div>
                            <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                            {' '}
                            {poll.imageUrl && <Button onClick={() => savePropertyFile('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                        </div>
                        <FormControl
                            type="file"
                            onChange={(e) => savePropertyFile('image', e.target.files[0] || null)}
                            inputRef={ref => imageInputRef.current = ref}
                            style={{ display: 'none' }}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
        {!!poll.answer.length
            ? <Table>
                <thead>
                    <tr>
                        <th>Пропустить вопрос [Ru]</th>
                        <th>Пропустить вопрос [En]</th>
                        <th width={40} />
                    </tr>
                </thead>
                <tbody>
                    {poll.answer?.map((answer) => (
                        <AnswerEditor
                            key={answer.id}
                            answer={answer}
                            poll={poll}
                            onDelete={() => deleteAnswer(answer)}
                        />
                    ))}
                </tbody>
            </Table>
            : <Button onClick={() => createAnswer({ textRu: 'Пропустить', textEn: 'Skip', type: 'skip' })}>
                Добавить пропуск вопроса
            </Button>
        }
    </>
}